import { GeekGlassesIcon } from "@/components/icons/geek-glasses";
import { SmileIcon } from "@/components/icons/smile-icon";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface ScienceBackedMessageProps {
  classNames?: {
    container?: string;
  };
}

export const ScienceBackedMessage = memo(function ScienceBackedMessage({
  classNames,
}: ScienceBackedMessageProps) {
  return (
    <div className={cn("flex w-full flex-col items-center gap-2 py-4", classNames?.container)}>
      <p className={cn(textVariants.footnote, "max-w-[300px] text-center")}>
        <span className="font-bold">Science-backed, lifestyle led</span>
        <br />
        Eat what you love, love how you feel
        <br />
        Without counting. Because I do it for you.
      </p>

      <div className="relative flex h-9 w-9 justify-center">
        <SmileIcon className="absolute top-0 left-0 z-10 h-9 w-9" />
        <GeekGlassesIcon className="absolute top-0 left-0 z-10 -translate-y-3/7 scale-80" />
      </div>
    </div>
  );
});
